import styles from "./vertical_input.module.css";
import {TextInput} from "../input/inputs";
import React from "react";

export default function VerticalInput({form, setForm}) {
    return (
        <div className={'d-flex'}>
            <div className={`${styles.inputContainer}`}>
                <div className={'d-flex'}>
                    <div style={{paddingTop: '12px', flexBasis: '50%'}}>Max tolerated value</div>
                    <div style={{flexBasis: '10%'}}></div>
                    <div style={{flexBasis: '25%'}}>
                        <TextInput name={'yellow_1'} hideName={true} form={form} setForm={setForm}/>
                    </div>
                </div>
                <div className={'d-flex'}>
                    <div style={{paddingTop: '12px', flexBasis: '50%'}}>Max desired value</div>
                    <div style={{flexBasis: '10%'}}></div>
                    <div style={{flexBasis: '25%'}}>
                        <TextInput name={'green_1'} hideName={true} form={form} setForm={setForm}/>
                    </div>
                </div>
                <div className={'d-flex'}>
                    <div style={{paddingTop: '12px', flexBasis: '50%'}}>Min desired value</div>
                    <div style={{flexBasis: '10%'}}></div>
                    <div style={{flexBasis: '25%'}}>
                        <TextInput name={'green_2'} hideName={true} form={form} setForm={setForm}/>
                    </div>
                </div>
                <div className={'d-flex'}>
                    <div style={{paddingTop: '12px', flexBasis: '50%'}}>Min tolerated value</div>
                    <div style={{flexBasis: '10%'}}></div>
                    <div style={{flexBasis: '25%'}}>
                        <TextInput name={'yellow_2'} hideName={true} form={form} setForm={setForm}/>
                    </div>
                </div>
            </div>
            <div className={styles.verticalLine}>
                <div className={`${styles.color} ${styles.yellow}`}></div>
                <div className={`${styles.color} ${styles.green}`}></div>
            </div>
        </div>
    );
}